import styled from 'styled-components';

const EntitySelectorTable = styled.div`
	position: relative;
	min-width: 360px;
	height: 360px;
	overflow-y: auto;

	&::-webkit-scrollbar {
		display: none;
	}

	div {
		padding: 10px 20px;
		text-align: center;
		font-family: 'GT Walsheim Pro';
		font-size: 16px;
		font-weight: 400;
		color: #e6e6e6;
		user-select: none;
		cursor: pointer;
		transition: background-color 0.25s ease;

		&:nth-child(odd) {
			background-color: #202020;
		}

		&:nth-child(even) {
			background-color: #000;
		}

		&:hover {
			background-color: #363636;
		}
	}
`;

export { EntitySelectorTable };
